import type { Strings } from "../i18n/strings";
import type { Lang } from "../lib/types";
import { LEGAL, type LegalKind } from "../content/legal";

export default function Legal({ t, lang, kind, onBack }: { t: Strings; lang: Lang; kind: LegalKind; onBack: () => void }) {
  const doc = LEGAL[lang][kind];
  return (
    <div className="screen">
      <div className="topbar">
        <button className="navbtn" onClick={onBack}>
          ← {t.back}
        </button>
        <span />
      </div>
      <div className="legal-scroll">
        <h1 className="legal-title">{doc.title}</h1>
        <p className="legal-effective">{doc.effective}</p>
        {doc.intro.map((p, i) => (
          <p key={i} className="legal-p">
            {p}
          </p>
        ))}
        {doc.sections.map((s, i) => (
          <div key={i} className="legal-section">
            <h2 className="legal-h">{s.h}</h2>
            {s.body.map((b, j) => (
              <p key={j} className="legal-p">
                {b}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
